// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"223b3c22","453":"72718526","551":"1275426c","842":"414fad6c"}[chunkId] + ".chunk.js";
};